import { useQuery } from '@tanstack/react-query';

import { type LeAgentMappingReportParams, getLeAgentMappingReport } from '~/services/ReportingService';

import { reportingQueryKeys } from './reportingQueryKeys';

type UseGetLeAgentMappingOptions = {
  enabled?: boolean;
};

export function useGetLeAgentMapping(
  params: LeAgentMappingReportParams = {},
  options: UseGetLeAgentMappingOptions = {},
) {
  return useQuery({
    enabled: options.enabled,
    queryKey: reportingQueryKeys.leAgentMapping(params.activeOn, params.department, params.subDepartment, params.limit),
    queryFn: ({ signal }) => getLeAgentMappingReport(params, { signal }),
    retry: false,
  });
}
